// src/services/api/TrackingService.js
import ApiService from '../base/BaseApiService';

/**
 * 認証トークンが存在するか確認する
 * @returns {boolean} - トークンが存在する場合はtrue、存在しない場合はfalse
 */
const existsAuthToken = () => {
  const token = localStorage.getItem('token');
  return token ? true : false;
}

/**
 * イベントを追跡する
 * @param {Object} eventData - イベントデータ
 * @param {string} eventData.name - イベント名
 * @param {Object} eventData.properties - イベントプロパティ
 * @returns {Promise<Object>} - 送信結果
 */
export const trackEvent = async (eventData) => {
   
  // 認証トークンがない場合は実行しない
  if (!existsAuthToken()) {
    console.error('認証トークンがないため。イベントトラッキングはキャンセルしました');
    return;
  }

  try {
    return await ApiService.post('/tracking/event', eventData);
  } catch (error) {
    console.error('イベント追跡エラー:', {
      errorId: error.errorId,
      eventType: eventData.name,
      properties: Object.keys(eventData.properties || {}).join(',')
    });
    
    // エラーダイアログは表示（BaseApiServiceのshowErrorDialogフラグを使用）
  }
};

/**
 * 良い評価のフィードバックを送信する
 * @param {string} queryId - クエリID
 * @param {string} feature - 機能名
 * @returns {Promise<Object>} - 送信結果
 */
export const trackGoodFeedback = async (queryId, feature) => {
  return trackEvent({
    name: 'InsuranceSearchFeedback',
    properties: {
      queryId,
      feature,
      evaluation: 'good'
    }
  });
};

/**
 * 悪い評価のフィードバックを送信する
 * @param {string} queryId - クエリID
 * @param {string} feature - 機能名
 * @param {Object} additionalData - 追加データ（理由など）
 * @returns {Promise<Object>} - 送信結果
 */
export const trackBadFeedback = async (queryId, feature, additionalData = {}) => {
  return trackEvent({
    name: 'InsuranceSearchFeedback',
    properties: {
      feature,
      evaluation: 'bad',
      ...additionalData,
      queryId // HACK: 引受目安でBadを押下した際場合にqueryIdが消えてしまうためadditionalDataより下に追加
    }
  });
};

/**
 * 例外を追跡する
 * @param {Error} exception - 例外オブジェクト
 * @param {Object} properties - 追加プロパティ
 * @returns {Promise<Object>} - 送信結果
 */
export const trackException = async (exception, properties = {}) => {

  // 認証トークンがない場合は実行しない
  if (!existsAuthToken()) {
    console.error('認証トークンがないため。例外トラッキングはキャンセルしました');
    return;
  }

  try {
    // 例外オブジェクトをシリアライズ可能な形式に変換
    const serializedError = {
      name: exception.name,
      message: exception.message,
      stack: exception.stack,
    };

    // APIリクエスト
    return await ApiService.post('/tracking/exception', {
      exception: serializedError,
      properties
    }, { 
        showErrorDialog: false, // エラーダイアログを表示しない
        tracking: {
            // エラーをトラッキングしない
            // > この設定しないと通信エラー時に無限ループするので注意
            // > 例：このメソッドをコール⇒通信エラー発生⇒... を繰り返す
            errors: false 
        }
    }); 
  } catch (error) {
    console.error('例外追跡エラー:', {
      errorMessage: error.message,
      exceptionType: exception.name,
      properties: Object.keys(properties || {}).join(',')
    });
    
    return null;
  }
};

export default {
  trackEvent,
  trackGoodFeedback,
  trackBadFeedback,
  trackException
};